module.exports = __webpack_public_path__ + "static/media/galerija_2019 (33).0f6a5186.jpg";